import React from 'react';
import './HelpModal.css';

export default function HelpModal({ onClose }) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-card">
        <h2>🧠 Habit Tracker Help</h2>
        <p>This section helps you build better routines and stay consistent with your personal goals. Here’s what each part means:</p>

        <ol>
          <li><strong>🎯 Daily Goals</strong> – Actionable, short-term items like “Drink water” or “Read 10 pages”. These reset daily.</li>
          <li><strong>🔥 Habits</strong> – Long-term streaks like “Workout”, “No sugar”, or “Code daily”. These stack up day-by-day.</li>
          <li><strong>📈 Streak Counters</strong> – Stay motivated with visual progress. Missing a day resets your streak.</li>
          <li><strong>💡 Tips</strong> – Hover over icons for tooltips, and check stats to see your top habits and trends over time.</li>
        </ol>

        <p>If you’re just starting, begin with 1–3 habits you really care about. <strong>Consistency &gt; perfection.</strong></p>
        <p><strong>ProdPilot’s habit tracker</strong> is designed to be lightweight and flexible — so it fits around your real life, not the other way around.</p>

        <h3>📋 About This App</h3>
        <p>
          I built <strong>ProdPilot</strong> to help creators and freelancers like myself stay focused and consistent. The habit tracker is a tool I personally use to maintain momentum in my daily life.
        </p>
        <p>
          This feature is part of a bigger idea: creating tools that help you get more done without burning out — tracking habits, building routines, and staying in flow.
        </p>
        <p>
          If this helps you too, consider <a href="https://buymeacoffee.com/prodpilot" target="_blank" rel="noopener noreferrer" className="inline-coffee-link">buying me a coffee</a> ☕ — it really helps support future updates.
        </p>

        <button onClick={onClose} className="modal-close-btn">Close</button>
      </div>
    </div>
  );
}
